import { Box } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const animateIn = (direction) => keyframes `
    0% {
      opacity: 0;
      transform: translateX(${direction === 'fromLeft' ? '-0.5rem' : '0.5rem'});
    }
    100% {
      opacity: 1;
      transform: none;
    }
  `;
export const StyledAnimatedChildren = styled.div `
  margin: 0;
  padding: ${({ theme }) => theme.spacing[200]} 0;
  animation: ${props => animateIn(props.fadeInAnimation)} 250ms ease-in-out;
`;
export const StyledHamburgerListItem = styled(Box) `
  display: flex;
  min-height: 5.2rem;
  flex-direction: row;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing[300]};
  border-top: ${({ theme }) => theme.borderWidth[25]} solid
    ${({ theme }) => theme.color.border.base};
  overflow: hidden;
`;
export const StyledHamburgerMenuImage = styled.div `
  display: flex;
  align-self: flex-end;
  margin-right: ${({ theme }) => theme.spacing[300]};
  width: 6.2rem;
  height: 4.2rem;
`;
//# sourceMappingURL=HamburgerMenu.styled.js.map